"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("../Map/Utils");
const vue_property_decorator_1 = require("vue-property-decorator");
const proj_1 = require("ol/proj");
const extent_1 = require("ol/extent");
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const EBecropController_1 = __importDefault(require("@becrop/components/EBecrop/Types/EBecropController"));
const DrawZoneHeader_vue_1 = __importDefault(require("./Components/DrawZoneHeader.vue"));
const FooterDrawZone_vue_1 = __importDefault(require("./Components/FooterDrawZone.vue"));
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const RecTooltip_vue_1 = __importDefault(require("./Components/RecTooltip.vue"));
const AlertCrop_vue_1 = __importDefault(require("./Components/AlertCrop.vue"));
const HeaderMap_vue_1 = __importDefault(require("@becrop/components/EBecrop/HeaderMap.vue"));
const FooterMap_vue_1 = __importDefault(require("./Components/FooterMap.vue"));
const GeoTIFF_1 = __importDefault(require("ol/source/GeoTIFF"));
const MapZone_1 = __importDefault(require("../Map/models/MapZone"));
let EBecropView = class EBecropView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.EBECROP_CONTROLLER = new EBecropController_1.default();
        this.MAP_CONTROLLER = new Controller_1.default();
        this.sliderValue = 100;
        this.lowResolutionCompletedCenter = false;
        this.hasModalAlertCrop = false;
    }
    get finishDrawAction() {
        return this.drawBuilder.finishDrawInteraction;
    }
    get drawBuilder() {
        return this.MAP_CONTROLLER.drawBuilder;
    }
    ;
    get zoneBuilder() {
        return this.MAP_CONTROLLER.zoneBuilder;
    }
    ;
    get currentField() {
        return this.EBECROP_CONTROLLER.currentField;
    }
    get sliderRangeValue() {
        return this.sliderValue * 3.2545;
    }
    get isOtherNavigator() {
        return navigator.userAgent.indexOf('Firefox') > -1;
    }
    get fields() {
        return this.EBECROP_CONTROLLER.fields;
    }
    get hasProductPermissions() {
        return this.EBECROP_CONTROLLER.hasProductPermissions;
    }
    get rasterBuilder() {
        return this.MAP_CONTROLLER.rasterBuilder;
    }
    async mounted() {
        localStorage.setItem("showAlertDifferentCrop", 'true');
        this.MAP_CONTROLLER.create('map_ebecrop', this.map_config.provider, this.map_config.apikey, 'recommendation-map-tooltip', '', '');
        this.startTimer();
        this.EBECROP_CONTROLLER.generateShortcuts();
        this.EBECROP_CONTROLLER.setProductPermissions(this.data.user.product_level);
        await this.EBECROP_CONTROLLER.getStoredFields(1);
        this.downloadStatesData();
    }
    setOpacityRaster() {
        const eBecropLayers = (0, Utils_1.findIncludeLayerById)('raster-layer', this.MAP_CONTROLLER.map);
        for (const eBecropLayer of eBecropLayers) {
            eBecropLayer.setOpacity(this.sliderValue / 100);
        }
    }
    updateFilterPixelsRaster() {
        this.setEBecropStyle(this.EBECROP_CONTROLLER.rasterFilterPixel);
    }
    updateFilterPanelExpanded() {
        if (this.EBECROP_CONTROLLER.isFilterPanelExpanded) {
            if (this.EBECROP_CONTROLLER.isFieldListExpanded) {
                this.EBECROP_CONTROLLER.setFieldListExpanded();
            }
        }
    }
    updateFieldListPanel() {
        if (this.EBECROP_CONTROLLER.isFieldListExpanded) {
            this.EBECROP_CONTROLLER.isFilterPanelExpanded = false;
        }
    }
    clearDrawZone() {
        if (!this.EBECROP_CONTROLLER.isCreateDrawingZone) {
            this.removeDrawLayer();
            this.EBECROP_CONTROLLER.isCreateDrawingZone = false;
        }
    }
    drawZone() {
        if (this.EBECROP_CONTROLLER.isActiveDrawingZone) {
            this.removeDrawLayer();
            (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
            this.EBECROP_CONTROLLER.currentField = null;
            this.drawBuilder.addDrawInteraction();
        }
        else {
            this.drawBuilder.removeDrawInteraction();
        }
    }
    updateMapState() {
        this.sliderValue = 100;
        (0, Utils_1.visibilityLayers)(false, 'raster-layer', this.MAP_CONTROLLER.map);
        this.removeDrawLayer();
        (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
        this.EBECROP_CONTROLLER.currentField = null;
        this.drawRaster(this.EBECROP_CONTROLLER.filteredState.url, `raster-layer-${this.EBECROP_CONTROLLER.filteredState.state}-high`, true);
    }
    get overlayBuilder() {
        return this.MAP_CONTROLLER.overlayBuilder;
    }
    addSelectStyleByFeature(name) {
        return (0, Utils_1.addSelectByFeature)(name, this.overlayBuilder, this.MAP_CONTROLLER.map, 'recommendation-map-tooltip');
    }
    async paintCurrentField() {
        if (this.EBECROP_CONTROLLER.currentField) {
            const actions = this.currentField.recSet.curatedRecommendations.length < 1 ? false : true;
            const fill = this.currentField.eBeCropDiagnostic.region ? '#ffffff00' : '#ffffff50';
            const geodata = this.currentField.polygon.toString();
            (0, Utils_1.removeLayerById)('zone-layer', this.MAP_CONTROLLER.map);
            (0, Utils_1.removeLayersById)('raster-layer', this.MAP_CONTROLLER.map);
            this.EBECROP_CONTROLLER.isCreateDrawingZone = false;
            this.zoneBuilder.drawZone(new MapZone_1.default({ geoData: geodata, fillColor: fill, zoneName: this.currentField.name, strokeColor: '#fff', centerZone: true, enableHoverInteraction: actions, enableSelectInteraction: actions, avg: 0, markers: [], preciseResult: false, strokeWidth: 6 }), (700), [170, 170, 170, 170]);
            if (this.currentField.recSet.recommendations.length < 1 && this.hasEbecropDiagnosticPassed(this.currentField) && this.currentField.recomendationsBrief === 'has_recommendations') {
                this.EBECROP_CONTROLLER.expandOrderPanel();
            }
            else {
                this.EBECROP_CONTROLLER.disabledOrderPanel();
            }
            this.EBECROP_CONTROLLER.service.data.forEach(state => this.paintRasterCurrentField(state));
            if (this.currentField.eBeCropDiagnostic.region) {
                this.drawBuilder.recortarLayerConWKT(this.map_config.provider, this.map_config.apikey, 'zone-layer');
            }
            if (!this.currentField.crop.name.toLowerCase().includes('corn') && localStorage.getItem('showAlertDifferentCrop') === 'true') {
                this.enableModalAlertCrop();
            }
            else {
                this.dismissModalAlertCrop();
            }
            if (this.currentField.recSet.curatedRecommendations.length > 0) {
                this.MAP_CONTROLLER.setZoneSelected(this.addSelectStyleByFeature(this.currentField.name));
            }
        }
        else {
            (0, Utils_1.removeLayersById)('zone-layer', this.MAP_CONTROLLER.map);
            (0, Utils_1.removeLayerById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
        }
    }
    hasEbecropDiagnosticPassed(field) {
        if (!field.eBeCropDiagnostic.acreage)
            return false;
        if (!field.eBeCropDiagnostic.region)
            return false;
        if (!field.eBeCropDiagnostic.crop)
            return false;
        return true;
    }
    async paintRasterCurrentField(state) {
        const source = new GeoTIFF_1.default({
            sources: [{ url: state.url, nodata: 255, max: 3, min: 0 }],
            interpolate: false,
        });
        const rasterView = await source.getView();
        const extent = rasterView.extent;
        const extentInProjection = (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
        const polygonExtension = (0, Utils_1.getExtensionOl)(this.currentField.polygon.toString());
        const doTheyIntersect = (0, extent_1.intersects)(extentInProjection, polygonExtension);
        if (doTheyIntersect) {
            this.drawRaster(state.url, `raster-layer-${state.state}-high`, false);
            this.EBECROP_CONTROLLER.updateResolution('high');
        }
    }
    dismissModalAlertCrop() {
        this.hasModalAlertCrop = false;
    }
    enableModalAlertCrop() {
        this.hasModalAlertCrop = true;
    }
    setSliderValue(value) {
        this.sliderValue = value;
    }
    removeDrawLayer() {
        (0, Utils_1.removeLayerById)('draw-polygon-layer', this.MAP_CONTROLLER.map);
        (0, Utils_1.removeLayerById)('draw-points-layer', this.MAP_CONTROLLER.map);
        (0, Utils_1.removeLayerById)('draw-basecopy-layer', this.MAP_CONTROLLER.map);
    }
    startTimer() {
        setTimeout(() => {
            location.reload();
        }, 15 * 60 * 1000);
    }
    confirmZone() {
        this.drawBuilder.recortarLayerConWKT(this.map_config.provider, this.map_config.apikey, 'draw-polygon-layer');
        this.EBECROP_CONTROLLER.isCreateDrawingZone = true;
        this.EBECROP_CONTROLLER.isActiveDrawingZone = false;
    }
    async centerLow() {
        const lowExtents = await Promise.all(this.EBECROP_CONTROLLER.service.data.map(async (state) => {
            const source = new GeoTIFF_1.default({
                sources: [{ url: state.url, nodata: 255, max: 3, min: 0 }],
                interpolate: false,
            });
            const rasterView = await source.getView();
            const extent = rasterView.extent;
            return (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
        }));
        const [minX, minY, maxX, maxY] = lowExtents.reduce(([minX, minY, maxX, maxY], extent) => [
            Math.min(minX, extent[0]), Math.min(minY, extent[1]),
            Math.max(maxX, extent[2]), Math.max(maxY, extent[3])
        ], [Infinity, Infinity, -Infinity, -Infinity]);
        (0, CenterUtility_1.center)(this.MAP_CONTROLLER.map, [minX, minY, maxX, maxY], 700, [100, 100, 100, 100]);
    }
    async drawRaster(url, name, center) {
        const exportSetup = this.EBECROP_CONTROLLER.ebecropRasterSetup(url, name);
        const geotiffConfig = exportSetup.geotiffConfig;
        const layerConfig = exportSetup.layerConfig;
        await this.rasterBuilder.drawRaster(geotiffConfig, layerConfig, center);
    }
    initCurrentField() {
        if (this.EBECROP_CONTROLLER.fields.length > 0 && !this.EBECROP_CONTROLLER.currentField && this.lowResolutionCompletedCenter) {
            this.EBECROP_CONTROLLER.currentField = this.EBECROP_CONTROLLER.fields[0];
        }
    }
    async downloadStatesData() {
        await this.EBECROP_CONTROLLER.init('low');
        if (this.EBECROP_CONTROLLER.fields.length === 0) {
            await this.centerLow();
            for (const state of this.EBECROP_CONTROLLER.getData) {
                await this.drawRaster(state.url, `raster-layer-low-${state.state}`, false);
            }
        }
        await this.EBECROP_CONTROLLER.init('hight');
        setTimeout(() => {
            this.lowResolutionCompletedCenter = true;
        }, 1000);
    }
    async setEBecropStyle(value) {
        this.EBECROP_CONTROLLER.setEBecropStyle(value, (0, Utils_1.findIncludeLayerById)('raster-layer', this.MAP_CONTROLLER.map));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EBecropView.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], EBecropView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('sliderValue')
], EBecropView.prototype, "setOpacityRaster", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.rasterFilterPixel')
], EBecropView.prototype, "updateFilterPixelsRaster", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.isFilterPanelExpanded')
], EBecropView.prototype, "updateFilterPanelExpanded", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.isFieldListExpanded')
], EBecropView.prototype, "updateFieldListPanel", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.isCreateDrawingZone')
], EBecropView.prototype, "clearDrawZone", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.isActiveDrawingZone')
], EBecropView.prototype, "drawZone", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.filteredState')
], EBecropView.prototype, "updateMapState", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('currentField')
], EBecropView.prototype, "paintCurrentField", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('EBECROP_CONTROLLER.fields'),
    (0, vue_property_decorator_1.Watch)('lowResolutionCompletedCenter')
], EBecropView.prototype, "initCurrentField", null);
EBecropView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { HeaderMap: HeaderMap_vue_1.default, DrawZoneHeader: DrawZoneHeader_vue_1.default, FooterDrawZone: FooterDrawZone_vue_1.default, FooterMap: FooterMap_vue_1.default, RecTooltip: RecTooltip_vue_1.default, AlertCrop: AlertCrop_vue_1.default }
    })
], EBecropView);
exports.default = EBecropView;
